import React from 'react';
import { Row, Col } from 'react-bootstrap';
import {
    TextGroup,
    Card,
    Text,
    TextTypes,
    Button,
    ButtonVariants,
    showToast,
    ToastVariants,
} from '../../index';
import { GiftCard } from '../../../types/graphql-global-types';
import CardWrapper from '../card-wrapper';
import CopyIcon from '../../../assets/copy.svg';
import util from '../../../util';
import moment from 'moment';

interface CardMobileProps {
    card: GiftCard;
    handlePrint?: () => void;
    balance: () => HTMLElement;
    cardImage: () => HTMLElement;
}

const CardMobile = ({ card, ...props }: CardMobileProps) => {
    const handleCopy = () => {
        const copied = util.copyToClipboard(card.giftcardnumber || '');
        showToast({
            title: copied ? 'Copied to Clipboard!' : 'Failed to copy!',
            content: '',
            variant: copied ? ToastVariants.SUCCESS : ToastVariants.DANGER,
        });
    };

    return (
        <Card className="order-card">
            <Row className="card-head justify-content-around">
                <div className="d-flex align-items-center">
                    <Text type={TextTypes.H4} className="card-name">
                        Card #{card.giftcardnumber}
                    </Text>
                    {props.handlePrint && (
                        <img alt="" src={CopyIcon} className="copy-icon" onClick={handleCopy} />
                    )}
                </div>
            </Row>
            <Row>
                <Col>{props.cardImage()}</Col>
            </Row>
            <Row>
                <TextGroup
                    label="Original Card Value"
                    value={'$' + (card.denomination?.toFixed(2) || '')}
                />
            </Row>
            <Row>
                <TextGroup label="Current Balance" value={props.balance()} />
            </Row>
            <Row>
                <TextGroup
                    label="Email Sent"
                    value={
                        <span>
                            {moment(moment.utc(card.emailsent)).local().format('MM/DD/YYYY')}
                            &nbsp;&nbsp;&nbsp;
                            {moment(moment.utc(card.emailsent)).local().format('h:mm A')}
                        </span>
                    }
                />
            </Row>
            {card.personalmessage && (
                <Row>
                    <TextGroup label="Message" value={card.personalmessage} />
                </Row>
            )}
            {props.handlePrint && (
                <Row>
                    <Col>
                        <Button
                            onClick={props.handlePrint}
                            variant={ButtonVariants.SECONDARY}
                            className="print-btn"
                        >
                            Print
                        </Button>
                    </Col>
                </Row>
            )}
        </Card>
    );
};

export default CardWrapper(CardMobile);
